(function () {

    console.info("script form loaded")

    document.querySelector('.custom-contact-form[form-url] #btn-form-submit').addEventListener('click', async e => {
        console.info("form loaded!.")
        const form = e.target.closest('form')
         
        if (form.checkValidity()) {

            const submitBtn = form.querySelector('[type="submit"]')
            submitBtn.disabled = true;
            e.preventDefault();
            let selectInvalid = false;


            // only for ambassador form
            if (form.getAttribute('form-url') == '3563261/us2a6bz') {
                for (let key of form.elements) {
                    if (key.getAttribute('type') == 'tel') {
                        if (document.querySelector('.phone-alert')) {
                            key.style.border = "1px solid #767676"
                            document.querySelector('.phone-alert').remove()
                        }
                        if (!isValidUSPhone(key.value)) {
                            const createPhoneAlert = document.createElement('div')
                            createPhoneAlert.className = "phone-alert"
                            createPhoneAlert.innerText = "Please enter a valid phone number."
                            key.style.border = "1px solid red"
                            key.closest('.form-group').append(createPhoneAlert);
                            key.focus();
                            submitBtn.disabled = false
                            return false;
                        }
                    }
                }
            }

            form.querySelectorAll('select[required]').forEach(select => {

                if (select.value == "" || select.value == "-1" || select.value.indexOf('Select') !== -1) {
                    const prevValue = select.value;
                    const border = select.style.border
                    select.value = "";
                    select.reportValidity();
                    select.focus();
                    select.style.border = "1px solid red";
                    setTimeout(() => {
                        // select.value = prevValue
                        select.style.border = border;
                    }, 1500)
                    submitBtn.disabled = false
                    selectInvalid = true;
                }
            })
            if (selectInvalid)
                return false;

            var formdata = new FormData();
            for (let key of form.elements) {
                if (key.getAttribute("name")) {
                    key.classList.remove('field-error');
                    if (key.selectedOptions) {
                        if (key.value.indexOf("Select") !== -1 || key.value == "-1" || key.value == "") {
                            formdata.append(
                                key.getAttribute("name"),
                                ""
                            );
                        }
                        else
                            formdata.append(
                                key.getAttribute("name"),
                                key.selectedOptions[0].innerText
                            );
                    } else if (key.type == 'file') {
                        if (key.files.length > 0) {
                            const s3Url = await aweFileUpload(key.files[0], form.getAttribute('form-location'))
                            formdata.append(key.getAttribute("name"), s3Url.Location);
                        }
                        else
                            formdata.append(key.getAttribute("name"), "");
                    }
                    else if (key.type == 'checkbox') {
                        if (key.checked) {
                            formdata.append(key.getAttribute("name"), key.value);
                        }
                    }
                    else
                        formdata.append(key.getAttribute("name"), key.value);

                }
            }
            
            if(form.getAttribute('form-url') == '16755338/2s0mqu3'){
                let recaptchaToken = grecaptcha.getResponse();
                if (!recaptchaToken) {
                    alert("Please verify you are not a robot.");
                    submitBtn.disabled = false;
                    return;
                }
                formdata.append('recaptcha', recaptchaToken)
            }
            const promise = await fetch(
                "https://hooks.zapier.com/hooks/catch/" + form.getAttribute('form-url'),
                {
                    method: "POST",
                    body: formdata,
                    redirect: "follow"
                }
            );
            const response = await promise.json();
            if (response && response.status == 'success') {
                $('.form-success--alert').show();
                submitBtn.style.display = "none"
                form.reset()
                if (!form.getAttribute('form-redirect-disable')) {
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 5000)
                } else {
                    setTimeout(() => {
                        $('.form-success--alert').hide();
                        submitBtn.style.display = "block"
                    }, 5000)
                }

            }

        }
        else {
            for (let element of form.elements) {
                if (element.validationMessage !== '')
                    element.classList.add('field-error');
                else
                    element.classList.remove('field-error');
            }
        }


    })


})()
function isValidUSPhone(phone) {
    const usPhoneRegex = /^(?:\+1\s?)?(?:\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
    return usPhoneRegex.test(phone.trim());
}

async function aweFileUpload(file, location) {

    // url example contact: https://awe-website.s3.amazonaws.com/contact/Exhaust%20clamps.png
    // support: https://awe-website.s3.amazonaws.com/support/IMG_2781.png
    AWS.config.update({ region: "us-east-1", credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: "us-east-1:82a553a6-e7e7-46df-b0c4-0fd03c6403a1" }) });

    return new AWS.S3.ManagedUpload({ params: { Bucket: "awe-website/" + location, ContentType: file.type, Key: file.name, Body: file } }).promise()

}